import { DefaultService } from "../DefaultService";

export default class B2BClienteLogisticaService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(...params) {
        return this._http.get(encodeURI(`${this._env}/b2blogistica/cliente/findall.json?param=${params}`), this._headers)
        .then(res => {
            return res.body;
        },
        err => {
            this.handleError(err);
        });
    }

    insertBulk(assClienteLogistica) {
        return this._http.post(`${this._env}/b2blogistica/cliente/insert-bulk`, assClienteLogistica, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }
}